<mat-tab-group (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedTabIndex">
    <mat-tab label="Account">
        <section class="edit_pass">
            <form class="example-form edit_email" [formGroup]="formGroupEmail" (ngSubmit)="onSubmitEmail()">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field">
                        <label for="userName">User Name</label>
                        <input matInput id="userName" formControlName="userName" placeholder="">
                    </mat-form-field>
                </div>
                <div class="form-row edit_rad">
                    <mat-form-field appearance="outline" class="form-field">
                        <label for="newPass">Email</label>
                        <input matInput id="email" formControlName="email" placeholder="">
                        <mat-error *ngIf="formGroup.get('newPass')?.hasError('required')">
                            Please Enter New email
                        </mat-error>
                    </mat-form-field>
                    <div class="btn-row dspdp-col-sm-offset-3 dspdp-col-sm-6 dsp-sm-6 sub_btn">
                        <button mat-raised-button color="primary" type="submit">Submit</button>
                    </div>
                </div>
            </form>

            <!-- <form class="example-form" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
                <div class="setting-page-account">
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <input matInput id="newPass" formControlName="newPass" placeholder="New Password">
                            <mat-error *ngIf="formGroup.get('newPass')?.hasError('required')">
                                Password is required.
                            </mat-error>
                            <mat-error *ngIf="formGroup.get('newPass')?.hasError('pattern')">
                                Password must be between 12–30 characters and include at least one uppercase letter, one
                                lowercase letter, one number, and one special character.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row con_pass">
                        <mat-form-field appearance="outline" class="form-field">
                            <input matInput id="confirmPass" formControlName="confirmPass"
                                placeholder="Confirm Password">
                            <mat-error *ngIf="formGroup.get('confirmPass')?.hasError('required')">
                                Please Enter Confirm Password
                            </mat-error>
                        </mat-form-field>
                        <span *ngIf="passwordMismatch" style="color: red; font-size: 12px; display: block;">
                            Password Missmatch
                        </span>
                    </div>


                    <div class="form-row btn">
                        <button mat-raised-button color="primary" type="submit"
                            [disabled]="formGroup.invalid">{{!isloading?'Submit':'Please Wait...'}}<mat-spinner *ngIf="isloading" diameter="20"></mat-spinner></button>
                        
                    </div>
                </div>
            </form> -->

        </section>
    </mat-tab>
    <mat-tab label="Blocked Members">
        <section class="my_friends favusers">
            <ul class="friends-section main-member-list-wrap no-list">
                <li id="friend9" class="member-detail-wrap" *ngFor="let req of blocked">
                    <figure class="img-holder">
                        <a>
                            <img src="{{req.profilePic}}" class="dsp_img3 iviewed-img" alt="Shawn">
                        </a>
                        <div class="wpee-user-status wpee-online"></div>
                    </figure>
                    <div class="user-details">
                        <h6 class="member-user-name">
                            <a>{{req.username}}</a>
                        </h6>
                        <div class="req_btns">
                            <span class=" req_btn unblock" (click)="unblock(req.blocked)">Unblock</span>
                        </div>
                    </div>
                </li>
                <div [ngClass]="{ 'shine': loader }">
                </div>
            </ul>
            <div class="profile-section-content" *ngIf="!loader && blocked.length == 0">
                <div id="m_list_friend" class="profile-section-content profile-friends-list">
                    <div class="box-border">
                        <div class="box-pedding">
                            <div class="page-not-found">
                                <span class="dsp_span_pointer"
                                    style="text-align: center; display: block; font-weight: bold;">
                                    No Blocked Users </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </mat-tab>
    <mat-tab label="Privacy">
        <section class="my_friends">
            <form class="example-form" [formGroup]="formGroupPrivacy" (ngSubmit)="onPrivacySubmit()">
                <div class="setting-page-account privacy_settings">
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <label for="employment">Who can view my pictures</label>
                            <mat-select id="employment" formControlName="pictures_privacy">
                                <mat-option value="">Select</mat-option>
                                <mat-option *ngFor="let privacy of privacyDropdown" [value]="privacy._id">{{
                                    privacy.name }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formGroupPrivacy.get('pictures_privacy')?.hasError('required')">
                                Please Who can view my pictures
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <label for="employment">Who can view my friends</label>
                            <mat-select id="employment" formControlName="friends_privacy">
                                <mat-option value="">Select</mat-option>
                                <mat-option *ngFor="let privacy of privacyDropdown" [value]="privacy._id">{{
                                    privacy.name }}</mat-option>

                            </mat-select>
                            <mat-error *ngIf="formGroupPrivacy.get('friends_privacy')?.hasError('required')">
                                Please Who can view my friends
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-row">
                        <div class="btn-row dspdp-col-sm-offset-3 dspdp-col-sm-6 dsp-sm-6 sub_btn">
                            <button mat-raised-button color="primary" type="submit">{{privacyUpdate?"Please Wait...":
                                "Submit" }}<mat-spinner *ngIf="privacyUpdate"
                                    class="custom-spinner"></mat-spinner></button>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </mat-tab>
   
</mat-tab-group>